import dynamic from "next/dynamic";
import Layout from "../../components/layout";
import Image from "next/image";
import { useCallback, useRef, useState, useEffect, useMemo } from "react";
// import Pagination from 'next-pagination'
import Pagination from "../../components/pagination";
import Link from "next/link";
import hm from "../../public/img/hm.png";
import kfc from "../../public/img/kfc.png";
import ph from "../../public/img/ph.png";
import can from "../../public/img/can.png";

const HeaderSlim = dynamic(() =>
  import("../../components/headerSlim").then((mod) => mod.HeaderSlim)
);
const GetFoot = dynamic(() =>
  import("../../components/foot").then((mod) => mod.Foot)
);

const Tenant = dynamic(() =>
  import("../../components/tenant").then((mod) => mod.Tenant)
);

function Direction() {
  const searchRef = useRef(null);
  const [query, setQuery] = useState("");
  const [active, setActive] = useState(false);
  const [results, setResults] = useState([]);
  const [category, setCategory] = useState([]);
  const [floors, setFloors] = useState([]);
  const [banner, setBanner] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  // const [totals, setTotal] = useState(0)
  // const [currentPage, setCurrentPage] = useState(0)
  // const [pagination, setPagination] = useState({ per_page: 12, current_page: 1 })
  // const [perPage, setPerPage] = useState(0)
  const [valueFloor, setValueFloor] = useState("");
  const [valueCategory, setValueCategory] = useState("");
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeAlfab, setActiveAlfab] = useState(null);

  const searchEndpoint = (query) =>
    `${process.env.NEXT_PUBLIC_ENV_PRODUCTION}v1/tenants?search=${query}&current_page=1&per_page=12`;
  const getAlphabeth = (query) =>
    `${process.env.NEXT_PUBLIC_ENV_PRODUCTION}v1/tenants?search=${query}&current_page=1&per_page=12&search_type=start`;
  const getPagination = (query) =>
    `${process.env.NEXT_PUBLIC_ENV_PRODUCTION}v1/tenants?search=&current_page=${query}&per_page=12`;
  const filterFloors = (query) =>
    `${process.env.NEXT_PUBLIC_ENV_PRODUCTION}v1/tenants?per_page=12&search=&current_page=1&per_page=12&category_id=&floor=${query}`;
  const getCategory = () =>
    `${process.env.NEXT_PUBLIC_ENV_PRODUCTION}v1/tenant-category`;
  const searchCategory = (query) =>
    `${process.env.NEXT_PUBLIC_ENV_PRODUCTION}v1/tenants?per_page=12&search=&current_page=1&per_page=12&category_id=${query}&floor=`;
  const getFloor = () => `${process.env.NEXT_PUBLIC_ENV_PRODUCTION}v1/floors`;
  const getSearchFloorCategoryPagination = (a, b, c, d) =>
    `${process.env.NEXT_PUBLIC_ENV_PRODUCTION}v1/tenants?search=${a}&current_page=${b}&per_page=12&category_id=${c}&floor=${d}&search_type=start&order_by=tenant_name&sort=ASC`;
  const dataBanner = () =>
    `${process.env.NEXT_PUBLIC_ENV_PRODUCTION}v1/tenant_banner`;

  const TENANT_PER_PAGE = 12;

  useEffect(() => {
    // fetch(searchEndpoint(''))
    //     .then(res => res.json())
    //     .then(res => {
    //         if(res.status != 400){
    //             setResults(res.data.tenants)
    //             setTotalPages(Math.ceil(res.data.total / TENANT_PER_PAGE))
    //             // console.log(res.data)
    //         } else {
    //             setResults([])
    //         }
    //     })
    onAllAlfabet();
    fetch(getCategory())
      .then((res) => res.json())
      .then((res) => {
        if (res.status != 400) {
          setCategory(res.data);
        } else {
          setCategory([]);
        }
        //   console.log(res.data)
      });
    fetch(getFloor())
      .then((res) => res.json())
      .then((res) => {
        if (res.status != 400) {
          setFloors(res.data);
          // console.log(res);
        } else {
          setFloors([]);
        }
        //   console.log(res.data)
      });
    fetch(dataBanner())
      .then((res) => res.json())
      .then((res) => {
        if (res.status != 400) {
          setBanner(res.data.banner);
        } else {
          setBanner([]);
        }
      });
  }, []);

  const handleClick = (num) => {
    setPage(num);
    const a = query;
    const b = num;
    const c = valueCategory;
    const d = valueFloor;
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetch(getSearchFloorCategoryPagination(a, b, c, d))
      .then((res) => res.json())
      .then((res) => {
        if (res.status != 400) {
          setResults(res.data.tenants);
          // console.log("pag", res.data.tenants);
        } else {
          setResults([]);
        }
      });
  };

  const onChange = useCallback((event) => {
    const query = event.target.value;
    setQuery(query);
    const a = query;
    const b = page;
    const c = valueCategory;
    const d = valueFloor;
    if (query.length) {
      fetch(getSearchFloorCategoryPagination(a, b, c, d))
        .then((res) => res.json())
        .then((res) => {
          if (res.status != 400) {
            setResults(res.data.tenants);
            setTotalPages(Math.ceil(res.data.total / TENANT_PER_PAGE));
          } else {
            setResults([]);
          }
        });
    } else {
      fetch(searchEndpoint(""))
        .then((res) => res.json())
        .then((res) => {
          if (res.status != 400) {
            setResults(res.data.tenants);
          } else {
            setResults([]);
          }
        });
    }
  }, []);

  const onFocus = useCallback(() => {
    setActive(true);
    window.addEventListener("click", onClick);
  }, []);

  // const onClick = useCallback((event) => {
  // if (searchRef.current && !searchRef.current.contains(event.target)) {
  //         setActive(false)
  //         window.removeEventListener('click', onClick)
  //     }
  // }, [])

  function onAlfabet(e, key) {
    const query = event.target.innerHTML;
    setActiveAlfab(key + 1);
    const a = query;
    const b = page;
    const c = valueCategory;
    const d = valueFloor;
    fetch(getSearchFloorCategoryPagination(a, b, c, d))
      .then((res) => res.json())
      .then((res) => {
        if (res.status != 400) {
          setResults(res.data.tenants);
          setTotalPages(Math.ceil(res.data.total / TENANT_PER_PAGE));
        } else {
          setResults([]);
        }
      }, []);
  }

  function onAllAlfabet() {
    setActiveAlfab("");
    const a = "";
    const b = page;
    const c = valueCategory;
    const d = valueFloor;
    fetch(getSearchFloorCategoryPagination(a, b, c, d))
      .then((res) => res.json())
      .then((res) => {
        if (res.status != 400) {
          setResults(res.data.tenants);
          setTotalPages(Math.ceil(res.data.total / TENANT_PER_PAGE));
        } else {
          setResults([]);
        }
      }, []);
  }

  function onCategory(e, key) {
    const query = e.id;
    setActiveCategory(query);
    fetch(searchCategory(query))
      .then((res) => res.json())
      .then((res) => {
        if (res.status != 400) {
          setResults(res.data.tenants);
        } else {
          setResults([]);
        }
      }, []);
  }

  function handleAllCategory(e) {
    const cate = event.target.value;
    setValueCategory(cate);
    const a = query;
    const b = page;
    const c = cate ? cate : "";
    const d = valueFloor;
    fetch(getSearchFloorCategoryPagination(a, b, c, d))
      .then((res) => res.json())
      .then((res) => {
        if (res.status != 400) {
          setResults(res.data.tenants);
          setTotalPages(Math.ceil(res.data.total / TENANT_PER_PAGE));
        } else {
          setResults([]);
        }
      }, []);
  }

  function handleChange(e) {
    const flo = event.target.value;
    setValueFloor(flo);
    const a = query;
    const b = page;
    const c = valueCategory;
    const d = flo ? flo : "";
    fetch(getSearchFloorCategoryPagination(a, b, c, d))
      .then((res) => res.json())
      .then((res) => {
        if (res.status != 400) {
          setResults(res.data.tenants);
          setTotalPages(Math.ceil(res.data.total / TENANT_PER_PAGE));
        } else {
          setResults([]);
        }
      }, []);
    // handle other stuff like persisting to store etc
  }

  let alphabet = [...Array(26).keys()].map((i) => String.fromCharCode(i + 97));

  return (
    <Layout title="Direction">
      <HeaderSlim />
      <div className="grid w-full">
        <div className="flex px-8 sm:px-8 md:px-16 lg:px-20 py-6">
          <Link href={"/"}>
            <span className="cursor-pointer text-xs sm:text-sm md:text-base lg:text-base sora purple-more font-light">
              Home{" "}
            </span>
          </Link>
          {/* <span className="text-xs sm:text-sm md:text-base lg:text-base purple-more font-light">&nbsp; &gt; &nbsp;</span> */}
          {/* <Link href={"/experience"}><span className="cursor-pointer text-xs sm:text-sm md:text-base lg:text-base sora purple-more font-light">Experience</span></Link> */}
          <span className="text-xs sm:text-sm md:text-base lg:text-base purple-more font-semibold">
            &nbsp; &gt; &nbsp;
          </span>
          <span className="text-xs sm:text-sm md:text-base lg:text-base sora purple-more font-semibold">
            Directory
          </span>
        </div>
      </div>
      <div className="grid w-full px-4">
        <div className="py-10 mb-0">
          <img src={banner} alt="logo" className="w-80 m-auto" />
        </div>
      </div>
      <div className="grid w-full">
        <div className="grid sm:grid md:flex lg:flex gap-0 sm:gap-4 md:gap-4 lg:gap-4 xl:gap-10 2xl:gap-16 px-4 sm:px-8 md:px-10 lg:px-20 py-6">
          <div className="grid">
            <select
              value={valueFloor}
              onChange={(e) => handleChange(e)}
              className="block w-full py-[10px] md:py-[7.5px] lg:py-[9.5px] pl-3 pr-12 appearance-none sora font-thin border border-full-purple arrow-down text-left rounded-none focus:outline-none text-sm mb-3"
            >
              <option value="">Choose Floor</option>
              {floors.map((data, key) => (
                <option key={key} value={data.id}>
                  {data.floor_name}
                </option>
              ))}
            </select>
          </div>
          <div className="grid">
            <select
              value={valueCategory}
              onChange={(e) => handleAllCategory(e)}
              className="block w-full py-[10px] md:py-[7.5px] lg:py-[9.5px] pl-3 pr-12 appearance-none sora font-thin border border-full-purple arrow-down text-left rounded-none focus:outline-none text-sm mb-3"
            >
              <option value="">All Category</option>
              {category.map((data, key) => (
                <option key={key} value={data.id}>
                  {data.tenan_category_name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex border-full-purple w-full sm:w-2/3 md:w-2/5 lg:w-1/3 block mb-3 md:10 lg:10">
            <div className="self-center px-3">
              <img
                src="/img/search.png"
                alt="Search"
                className="w-[30px] inline-block"
              />
            </div>
            <input
              className="text-sm bg-transparent focus:outline-none purple-more py-[10px] md:py-[7.5px] lg:py-[9.5px] pr-3 w-full"
              onChange={onChange}
              // onFocus={onFocus}
              placeholder="What are you looking for ?"
              type="text"
              value={query}
            />
            <button
              type="button"
              className="text-sm sm:text-sm md:text-base lg:text-base text-center text-white sora font-light purple-dart py-2 px-10"
            >
              Search
            </button>
          </div>
          {/* <div className="grid">
            
          </div> */}
          {/* <div className="overflow-hidden">
                        <div className="flex flex-nowrap overflow-x-scroll no-scrollbar"> 
                            <button type="button" onClick={() => onAllCategory()} className={`whitespace-nowrap text-xs sm:text-sm text-center sora font-light purple-more py-[10px] md:py-[7.5px] lg:py-[10px] px-4 ${activeCategory ? '' : 'purple-young'}`}>All Category</button> 
                            {   category.map((data, key) => (
                                    <button key={key} onClick={() => onCategory(data, key)} type="button" className={`whitespace-nowrap text-xs sm:text-sm text-center sora font-light purple-more py-[9px] px-6 ${activeCategory === data.id ? 'purple-young' : ''}`}>{data.tenan_category_name}</button> 
                                )) 
                            } 
                        </div> 
                    </div> */}
        </div>
      </div>
      <div className="grid w-full">
        <div className="overflow-hidden px-4 sm:px-8 md:px-10 lg:px-20">
          <div className="flex flex-nowrap overflow-x-scroll border-t border-b border-[#DACAFF] py-[10px] md:py-[7.5px] lg:py-[15px] no-scrollbar">
            <button
              type="button"
              onClick={() => onAllAlfabet()}
              className={`whitespace-nowrap text-xs sm:text-sm text-center sora font-normal purple-more min-w-[45px] min-h-[45px] ${
                activeAlfab ? "" : "active-alfa"
              }`}
            >
              All
            </button>
            {/* <button type="button" className="whitespace-nowrap text-xs sm:text-sm text-center sora font-normal purple-more min-w-[45px] min-h-[45px] uppercase">#</button> */}
            {alphabet.map((data, key) => (
              <button
                type="button"
                onClick={(e) => onAlfabet(e, key)}
                key={key}
                className={`whitespace-nowrap text-xs sm:text-sm text-center sora font-normal purple-more min-w-[45px] min-h-[45px] uppercase ${
                  activeAlfab === key + 1 ? "active-alfa" : ""
                }`}
              >
                {data}
              </button>
            ))}
          </div>
        </div>
      </div>
      <Tenant dataTenants={results} />
      <div className="grid w-full justify-center mt-10 mb-20">
        {/* <Pagination currentPage={currentPage || 1} totalPage={Math.ceil(totals / perPage) || 12} onChangePage={onChangePagination}/> */}
        <div className="flex mb-5 m-auto">
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            handleClick={handleClick}
          />
          {/* <button type="button" className="text-xs sm:text-sm text-center sora font-normal purple-more min-w-[35px] min-h-[35px] purple-young rounded-full mx-1.5">1</button>
                    <button type="button" className="text-xs sm:text-sm text-center sora font-normal purple-more min-w-[35px] min-h-[35px] mx-1.5">2</button>
                    <button type="button" className="text-xs sm:text-sm text-center sora font-normal purple-more min-w-[35px] min-h-[35px] mx-1.5">3</button>
                    <button type="button" className="text-xs sm:text-sm text-center sora font-normal purple-more min-w-[35px] min-h-[35px] mx-1.5">4</button>
                    <button type="button" className="text-xs sm:text-sm text-center sora font-normal purple-more min-w-[35px] min-h-[35px] mx-1.5">5</button> */}
        </div>
        <div className="!border-b-4 border-pink w-32 m-auto"></div>
      </div>
      <footer className="grid w-full">
        <GetFoot />
      </footer>
    </Layout>
  );
}

export default Direction;
